import { Widget, WIDGET_CHUNK_NAME } from "@gaming/srvg-classes-core";


export class ChunkNameWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {

        options = options || {};
        options.selector = options.selector || '#chunknameWidget';
        super( options );

        this.name = 'widgetchunkname';
        this.widgetName = options.widgetName || WIDGET_CHUNK_NAME;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addChunkNameWidget();
        super.handleDomInstantiated();
    }

    /**
     * add matrix widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addChunkNameWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addChunkNameWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addChunkNameWidget(element);
    }



}